import { TUserRole, TUserStatus } from "../services/schemas";
import { UserRole } from "@libs/shared-permissions";

export const getMemberRoles = (
  currentUserRole?: UserRole
): {
  label: string;
  value: TUserRole;
}[] => {
  const baseRoles = [
    { label: "Member", value: "clientUser" as TUserRole },
    { label: "Admin", value: "clientAdmin" as TUserRole }
  ];

  if (currentUserRole === "systemAdmin") {
    baseRoles.push({ label: "System Admin", value: "systemAdmin" as TUserRole });
  }

  return baseRoles;
};

export const memberRoles = getMemberRoles();

export const memberStatuses: {
  label: string;
  value: TUserStatus;
}[] = [
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" }
];

export const formatStatus = {
  active: "Active",
  pending: "Pending",
  inactive: "Inactive"
};

export const ACCEPTED_FILE_TYPES = ["image/jpeg", "image/jpg", "image/png", "image/webp"];
export const MAX_FILE_SIZE = 5 * 1024 * 1024;
